<ol class="action-bar-table">
  <li class="item-bar pr-lg-1" *ngFor="let act of actionNames">
    <a class="btn" [class.disabled]="act.disabled && (disabledAction || act.customDisplay)"
       (click)="!(act.disabled && disabledAction) && execute(act.actionType)" id="cs-action-bar-button-{{act.label}}-{{actionId}}">
      <i class="action-icon" [ngClass]="act.icon"></i><span class="ml-1">{{act.label}}</span>
      <i class="cil-chevron-bottom-alt"></i>
    </a>
  </li>
</ol>
